import App from './core/App.js'
import './styles/base.css'

const app = new App(document.getElementById('app'))
app.init()